import type { ElForm } from 'element-ui/types/form';
import { Component, Vue, Prop } from 'vue-property-decorator';

interface taxesItem {
  beginBalance?: number;
  endBalance?: number;
  taxTactics?: Array<{
    value?: number;
    type?: number;
  }>;
}

@Component
export default class Tax extends Vue {
  $refs: {
    taxForm: ElForm;
  };

  @Prop({ default: 0 })
    index: number;

  @Prop()
    data: taxesItem;

  @Prop()
    disabled: boolean;

  public requireRules = [{ required: true, message: '不能为空', trigger: 'blur' }];
  public rules = {
    beginBalance: [{ required: true, validator: this.validateBegin, message: '', trigger: 'blur' }],
    endBalance: [{ required: true, validator: this.validateEnd, message: '', trigger: 'blur' }],
  };

  validateBegin(rules, value, callback) {
    if (value === ' ' || value === undefined) {
      callback(new Error('不能为空'));
    } else if (this.data.endBalance < value) {
      callback(new Error('金额1不能大于金额2'));
    } else {
      callback();
    }
  }

  validateEnd(rules, value, callback) {
    if (value === '' || value === undefined) {
      callback(new Error('不能为空'));
    } else if (value < this.data.beginBalance) {
      callback(new Error('金额2不能小于金额1'));
    } else {
      callback();
    }
  }

  /**
   * 删除扣减项/比例项
   */
  public delCutOrRatioItem(targetIndex) {
    if (!this.disabled) {
      this.data.taxTactics.splice(targetIndex, 1);
    }
  }

  /**
   * 增加扣减项/比例项
   */
  public addCutOrRatioItem(flag: number) {
    this.data.taxTactics.push({
      value: 0,
      type: flag,
    });
  }

  public deleteTarget(index) {
    if (!this.disabled) {
      this.$emit('deleteIndex', index);
    }
  }
}
